import React from "react";
import { useTable } from "../../Components/useTable";

const MomentsRejected = () => {
  const type = "Rejected Moments";
  const limitPerpage = 100;
  const pageRowslinit = [100, 200, 500, 1000];
  const headCells = [
    { id: "code", numeric: false, label: "User Code" },
    { id: "username", numeric: false, label: "User Name" },
    { id: "picture", numeric: false, label: "Moment Image" },
    { id: "country", numeric: false, label: "Country" },
    { id: "fileType", numeric: false, label: "File Type" },
    { id: "status", numeric: false, label: "Status" },
    { id: "dropdown", numeric: false, label: "Change Status" },
    { id: "description", numeric: false, label: "Description" },
    // { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default MomentsRejected;
